"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlphaNumeric = exports.stringOrEmpty = exports.isTrueString = exports.stringOrArrayAsArray = exports.convertFromHumanToConstant = exports.convertJSONFileNameToConstant = exports.convertFromConstantToJSONFileName = exports.convertFromJSVariableToDBColumnName = exports.convertFromJSVariableToHuman = exports.convertFromCamelToHuman = exports.convertFromCamelToSeparated = exports.convertFromHumanToCamel = exports.convertFromDBColumnNamesToJSVariableNames = exports.convertFromConstantToJSVariableName = exports.dbColumnNameToJSVariableName = exports.convertFromConstantToCamel = exports.convertFromConstantToHuman = void 0;
function convertFromConstantToHuman(constant) {
    return constant
        .split('_')
        .map((s) => {
        return constantToCapitalizedWord(s);
    })
        .join(' ');
}
exports.convertFromConstantToHuman = convertFromConstantToHuman;
function convertFromConstantToCamel(constant) {
    return constant
        .split('_')
        .map((s) => {
        return constantToCapitalizedWord(s);
    })
        .join('');
}
exports.convertFromConstantToCamel = convertFromConstantToCamel;
function dbColumnNameToJSVariableName(key) {
    return key
        .toLowerCase()
        .split('_')
        .map((s, index) => {
        if (index > 0) {
            return s.charAt(0).toUpperCase() + s.substring(1);
        }
        else {
            return s;
        }
    })
        .join('');
}
exports.dbColumnNameToJSVariableName = dbColumnNameToJSVariableName;
function convertFromConstantToJSVariableName(key) {
    return dbColumnNameToJSVariableName(key);
}
exports.convertFromConstantToJSVariableName = convertFromConstantToJSVariableName;
function convertFromDBColumnNamesToJSVariableNames(result) {
    const newResult = {};
    Object.keys(result)
        .forEach((key) => {
        newResult[dbColumnNameToJSVariableName(key)] = result[key];
    });
    return newResult;
}
exports.convertFromDBColumnNamesToJSVariableNames = convertFromDBColumnNamesToJSVariableNames;
function convertFromHumanToCamel(human) {
    return human
        .split(' ')
        .map((s) => {
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.substring(1);
    })
        .join('');
}
exports.convertFromHumanToCamel = convertFromHumanToCamel;
function convertFromCamelToSeparated(camel, separator) {
    let human = '';
    let prevWasUpper = false;
    if (!camel) {
        return '';
    }
    for (let i = 0; i < camel.length; i++) {
        const ch = camel.charAt(i);
        if (i > 0 && ch === ch.toUpperCase()) {
            if (!prevWasUpper) {
                human += separator;
            }
            else {
                if (i + 1 < camel.length) {
                    const next = camel.charAt(i + 1);
                    if (next === next.toLowerCase()) {
                        human += separator;
                    }
                }
            }
        }
        prevWasUpper = (ch === ch.toUpperCase());
        human += ch;
    }
    return human;
}
exports.convertFromCamelToSeparated = convertFromCamelToSeparated;
function convertFromCamelToHuman(camel) {
    return convertFromCamelToSeparated(camel, ' ');
}
exports.convertFromCamelToHuman = convertFromCamelToHuman;
function convertFromJSVariableToHuman(jsVar) {
    const separated = convertFromCamelToSeparated(jsVar, ' ');
    if (separated.length > 0) {
        return separated.charAt(0).toUpperCase() + separated.substring(1);
    }
    else {
        return separated;
    }
}
exports.convertFromJSVariableToHuman = convertFromJSVariableToHuman;
function convertFromJSVariableToDBColumnName(js) {
    return convertFromCamelToSeparated(js, '_').toLowerCase();
}
exports.convertFromJSVariableToDBColumnName = convertFromJSVariableToDBColumnName;
function convertFromConstantToJSONFileName(constant) {
    return constant
        .split('_')
        .join('-')
        .toLowerCase();
}
exports.convertFromConstantToJSONFileName = convertFromConstantToJSONFileName;
function convertJSONFileNameToConstant(json) {
    return json
        .split('-')
        .join('_')
        .toLowerCase();
}
exports.convertJSONFileNameToConstant = convertJSONFileNameToConstant;
function convertFromHumanToConstant(human) {
    return human.toUpperCase()
        .split(' ')
        .join('_');
}
exports.convertFromHumanToConstant = convertFromHumanToConstant;
function stringOrArrayAsArray(value) {
    if (!value) {
        return [];
    }
    if (value instanceof Array) {
        return value;
    }
    else {
        return [value];
    }
}
exports.stringOrArrayAsArray = stringOrArrayAsArray;
const SPECIAL_HUMAN_CASES = [
    'FX', 'MM', 'LCR', 'HQLA', 'ISIN', 'SLS', 'IRS', 'NSFR', 'FTP', 'EOD'
];
function constantToCapitalizedWord(constant) {
    if (SPECIAL_HUMAN_CASES.includes(constant)) {
        return constant;
    }
    else {
        constant = constant.toLowerCase();
        return constant.charAt(0).toUpperCase() + constant.substring(1);
    }
}
function isTrueString(str, valueIfMissing) {
    if (!str) {
        if (valueIfMissing) {
            return valueIfMissing;
        }
        else {
            return false;
        }
    }
    const strUpper = str.toUpperCase();
    return (strUpper === 'TRUE' || strUpper === 'T' || strUpper === 'YES' || strUpper === 'Y');
}
exports.isTrueString = isTrueString;
function stringOrEmpty(value) {
    if (!value) {
        return '';
    }
    return value.toString();
}
exports.stringOrEmpty = stringOrEmpty;
function isAlphaNumeric(value) {
    return value.match(/^[a-z0-9]+$/i) !== null;
}
exports.isAlphaNumeric = isAlphaNumeric;
//# sourceMappingURL=string-utils.js.map